module.exports = __webpack_public_path__ + "img/rosepetal-dep-montanacolors.9646479d.jpg";